import { Component, input } from '@angular/core';
import { IconComponent } from '@components';

@Component({
  selector: 'app-benefit',
  templateUrl: './benefit.component.html',
  styleUrl: './benefit.component.scss',
  imports: [IconComponent],
})
export class BenefitComponent {
  readonly description = input<string>('');
  readonly icon = input<string>('');
  readonly title = input<string>('');
}
